export const ROLE_GROUP_CLONE_STATUS = 'ROLE_GROUP_CLONE_STATUS'
export const SET_CLONE_ID = 'SET_CLONE_ID'
export const ROLE_GROUP_CLONED = 'ROLE_GROUP_CLONED'
export const SET_SHOW_SELECTED_ROLE_GROUP = 'SET_SHOW_SELECTED_ROLE_GROUP'
export const SET_ROLE_GROUP_SEARCH_VALUE = 'SET_ROLE_GROUP_SEARCH_VALUE'
export const SET_ASSOCIATED_GROUP_SEARCH = 'SET_ASSOCIATED_GROUP_SEARCH'
export const RESET_ROLE_GROUPS = 'RESET_ROLE_GROUPS'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'
